<script>
  // import departments from "@data/departments.json";
  import colorScale from "../helpers/departmentTypeColorScale.js";

  let types = colorScale.domain(); // [...new Set(departments.map((d) => d["Department Type"]))];
  import { fade } from "svelte/transition";
</script>

<div class="legend" transition:fade>
  {#each types.filter((d) => d != "General Debt Service" && d != "General Government") as type}
    <div class="item">
      <span class="dot" style="background-color: {colorScale(type)}" />
      <span class="label">{type}</span>
    </div>
  {/each}
</div>

<style>
  .legend {
    /* width: 100%; */
    display: flex;
    flex-wrap: wrap;
    place-items: center;
    justify-content: center;
  }
  .item {
    display: flex;
    place-items: center;
    justify-content: center;
    margin-right: 10px;
    margin-bottom: 2px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    margin-right: 5px;
  }

  .label {
    font-size: 1rem;
    font-family: var(--font-serif);
  }

  @media screen and (max-width: 568px) {
    .label {
      font-size: 0.9rem;
    }
  }
</style>
